import {GetStaticProps} from 'next'

import SEO from 'components/elements/SEO'
import TemplateTermsAndConditions from 'components/templates/TemplateTermsAndConditions'
import {TPageComponent} from 'src/types'
import {TermsAndConditionsPage} from 'src/types/__sanitySchema__'
import {getKeywords} from 'src/utils'

import sanityClient from '../backend/lib/sanityClient'

interface ITermsAndConditionsProps {
	pageContent: TermsAndConditionsPage
}

const TermsAndConditions: TPageComponent<ITermsAndConditionsProps> = ({pageContent}) => {
	return (
		<>
			<SEO
				title={pageContent?.seo?.seo_title || pageContent?.title}
				description={pageContent?.seo?.meta_description}
				keywords={getKeywords(pageContent?.seo?.focus_keyword, pageContent?.seo?.focus_synonyms)}
			/>
			<TemplateTermsAndConditions pageContent={pageContent} />
		</>
	)
}

export const getStaticProps: GetStaticProps<ITermsAndConditionsProps> = async () => {
	try {
		const TermsAndConditionsPage = (
			await sanityClient.fetch<TermsAndConditionsPage[]>('*[_type == "termsAndConditionsPage"]')
		)[0]

		return {
			props: {
				pageContent: {...TermsAndConditionsPage},
			},
		}
	} catch {
		return {
			notFound: true,
		}
	}
}

TermsAndConditions.displayName = 'TermsAndConditions'

export default TermsAndConditions
